import type * as React from 'react';
import { get } from '@Domain/Api';
import aiCostSummaryFetched, {
	type AiCostSummaryFetchedAction,
	type AiCostSummaryFetchedPayload,
} from '@Application/AiCosts/Actions/aiCostSummaryFetched';
import aiCostSummaryFetchFailed, {
	type AiCostSummaryFetchFailedAction,
} from '@Application/AiCosts/Actions/aiCostSummaryFetchFailed';
import type FetchAiCostSummary from '@Application/AiCosts/Queries/FetchAiCostSummary';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = AiCostSummaryFetchedAction | AiCostSummaryFetchFailedAction;

export default (query: FetchAiCostSummary) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const baseUrl = `${parameters.api.host}/api/accounts/${query.accountId}/ai-costs/summary`;
			const queryString = query.toQueryString();
			const url = queryString.length > 0 ? `${baseUrl}?${queryString}` : baseUrl;

			const payload = await get<AiCostSummaryFetchedPayload>(url);

			const action = aiCostSummaryFetched(payload, query.accountId, query.queryKey);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiCostSummaryFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
